<template>
    <div class="cart-list ps" v-if="isCordova || isOnlineOrder">
        <h4 >
            取餐方式
        </h4>
        <el-radio-group v-model="radioTake" class="radio-tick-shadow mt-2 mb-3">
            <el-radio v-if="orderDeliveryList.includes('1')" label="1">
                <div class="title">自取</div>
                <div v-if="false" class="fee red">6折</div>
            </el-radio>
            <el-radio :disabled="deliveryFee===Infinity" v-if="orderDeliveryList.includes('2')" label="2">
                外送
                <div class="add">
                    <span class="small gray">{{userAddressData.city}}{{userAddressData.township}}{{userAddressData.address}}</span>
                </div>
                <div class="edit-btn" @click="$router.push({name: 'OrderAddressList'})">
                    <img src="@/assets/images/edit2.svg">
                </div>
                <div v-if="false" class="fee red">${{deliveryFee}}</div>
            </el-radio>
        </el-radio-group>
        <div class="li">
          時間
          <div class="float-right" @click="openPickTime">
            <span class="yellow">{{storeInfo.reservationTime === '' ? ['','少於'+(15+userAddressTime)+'分鐘',(15+userAddressTime)+'-'+(30+userAddressTime)+'分鐘',(30+userAddressTime)+'-'+(45+userAddressTime)+'分鐘','大於'+(45+userAddressTime)+'分鐘'][mealPreparationTimeType] : storeInfo.reservationTitle}}</span>&nbsp;&nbsp;<i class="el-icon-edit"/>
          </div>
        </div>
        <pick-time v-if="isOpenPickTime" :value="isOpenPickTime" @result="closePickTime"/>
    </div>
</template>
<script>
    import PickTime from "../components/PickTime";
    import * as constDefine from '@/store/constDefine';
    import {notNull} from '@/util/common';
    import * as mutationTypes from "@/store/mutationTypes";
    import utilDate from "@/util/date";

    export default {
        name: "DeliveryBlock",
        components: {
          PickTime, //選擇其他時間週期
        },
        props: {
            fromRoute:{},
        },
        data() {
            return {
                orderSettingTypeId: this.$store.state.cartPageSnapshot.orderSettingTypeId,
                radioTake: this.$store.state.cartPageSnapshot.radioTake,
                orderDeliveryList:this.$store.state.cartPageSnapshot.orderDeliveryList,//取餐方式（自取、外送、小短腿）
                userAddressData:this.$store.state.cartPageSnapshot.userAddressData,
                mealPreparationTimeType:this.$store.state.cartPageSnapshot.mealPreparationTimeType,//餐點平均準備時間
                deliveryConditionList:this.$store.state.cartPageSnapshot.deliveryConditionList,//外送費資訊
                storeId: Number(this.$route.query.storeId?this.$route.query.storeId:this.$store.state.cartStoreId),//店家id(query過來的是修改訂單)
                shoppingCartMealChoiceList: this.$store.state.cartPageSnapshot.shoppingCartMealChoiceList, //購物車中的餐點資訊
                originTotalPrice: this.$store.state.cartPageSnapshot.originTotalPrice,    //小計
                oldOriginTotalPrice: this.$store.state.cartPageSnapshot.oldOriginTotalPrice, //用優惠前小計
                userAddressId:this.$store.state.cartPageSnapshot.userAddressId,
                userAddressParams: this.$store.state.cartPageSnapshot.userAddressParams,
                storeInfo:this.$store.state.cartPageSnapshot.storeInfo,
                //挑選其他餐期時間
                isOpenPickTime: false,
                removeSubscribe: {},
                time: null,
                dateList: this.$store.state.pickTimeData.dateList,
                periodList: this.$store.state.pickTimeData.periodList,
                isCordova: this.$public.isCordova(),
                isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
                isDelivery: false,
                isTableOrderAddItem: false,
            }
        },
        created() {
            // this.setupData();
            this.updateOrderSettingTypeId()

            try {
                let dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                    this.isTableOrderAddItem = true
                }
            } catch (e) {
                this.isTableOrderAddItem = false
            }
        },
        mounted() {
            this.removeSubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type==="updateCartOnlineOrderAndOtherSetting") {
                    this.orderDeliveryList = mutation.payload.orderDeliveryList;
                    this.userAddressData = mutation.payload.userAddressData;
                    this.mealPreparationTimeType = mutation.payload.mealPreparationTimeType;
                    this.deliveryConditionList = mutation.payload.deliveryConditionList;
                    this.storeInfo = mutation.payload.storeInfo;
                }
                if (mutation.type==="updateCartFinalPrice") {
                    this.finalPrice = mutation.payload;
                    this.getOrderGiftCouponApi(this.finalPrice);
                }
                if (mutation.type==="updateCartOriginTotalPrice") {
                    this.originTotalPrice = mutation.payload;
                }
                if (mutation.type === "updateCartOldOriginTotalPrice") {
                    this.oldOriginTotalPrice = mutation.payload;
                }
                if (mutation.type==="updateShoppingCartMealChoiceList") {
                    this.shoppingCartMealChoiceList = mutation.payload;
                }
                if (mutation.type ==="updateCartRadioTake") {
                  this.radioTake = mutation.payload;
                  this.updateOrderSettingTypeId()
                }
                if (mutation.type === mutationTypes.setOrderSettingTypeId) {
                    this.orderSettingTypeId = mutation.payload;
                }
                if (mutation.type ==="updateCartUserAddressId") {
                    this.userAddressId = mutation.payload;
                }
                if (mutation.type === mutationTypes.setOrderStoreInfo) {
                  this.storeInfo = this.$store.state.orderStoreInfo

                  let datePeriodData = utilDate.getDatePeriodList(new Date(), this.storeInfo.reservationDay)
                  this.dateList = datePeriodData.dateList
                  this.periodList = datePeriodData.periodList
                  this.$store.commit(mutationTypes.setPickTimeData, {
                    dateList: datePeriodData.dateList,
                    periodList: datePeriodData.periodList,
                  });
                }
                if (mutation.type === mutationTypes.setOpenPickTime) {
                  if(this.$store.state.openPickTime) {
                    this.openPickTime()
                    this.$store.commit(mutationTypes.setOpenPickTime, false);
                  }
                }
            });
        },
        destroyed() {
          this.removeSubscribe();
        },
        methods: {
            getOrderGiftCouponApi(finalPrice) {
              let totalPrice = finalPrice - (this.radioTake === '2' ? this.deliveryFee : 0)

              if(!this.isCordova && !this.isOnlineOrder && this.isTableOrderAddItem) {
                return false;
              }

              this.stopGetOrderGiftCouponApi();

              this.time = setTimeout(() => {
                this.$http.fetchWithAuth`GetOrderGiftCoupon${{
                  storeId: this.storeId,
                  totalPrice: totalPrice,
                  orderSettingTypeId: this.orderSettingTypeId,
                }}
                ${json => {
                  let tempArr = [];
                  if (notNull(json.data)) {
                    for (const key in json.data) {
                      if (Object.hasOwnProperty.call(json.data, key)) {
                        const element = json.data[key];
                        tempArr = tempArr.concat(element);
                      }
                    }
                    this.orderGift = tempArr;
                    this.$store.commit("updateCartOrderGift", this.orderGift);
                  }
                }}`;
              },1000);
            },
            stopGetOrderGiftCouponApi() {
              if (this.time) {
                clearTimeout(this.time)
              }
            },
            setupData(){
                if (notNull(this.fromRoute) &&
                    (
                        ['OrderAddressList', 'OrderCouponList', 'OrderDetail'].indexOf(this.fromRoute.name) !== -1 ||
                        (['OrderList'].indexOf(this.fromRoute.name) !== -1 && this.userAddressId === -1)
                    )
                ) {  // 取得外送地址資訊(8)
                        if (this.userAddressId > 0 || this.userAddressId === -1) {
                            this.$http.fetchWithAuth`GetUserAddress${{
                                'id': this.userAddressId,
                                'targetLat': this.storeInfo.storeLat,
                                'targetLng': this.storeInfo.storeLng,
                                'storeId': this.storeInfo.storeId,
                                'getTime': true,
                                'locationStoreId': (this.userAddressId === -1 ? this.userAddressParams.storeId : 0),
                                'locationTableId': (this.userAddressId === -1 ? this.userAddressParams.tableId : 0),
                                }}
                            ${json => {
                                if (json.status) {
                                    this.userAddressData = json.data.userAddressData;
                                    this.$store.commit("updateCartUserAddressData", this.userAddressData);
                                    this.userAddressId = 0;
                                    if(this.userAddressParams.isDelivery) {
                                        this.isDelivery = true
                                        this.userAddressParams.isDelivery = false
                                    }
                                }
                            }}`;
                        }
                }
            },
            openPickTime() {
              if(!this.storeInfo.isDeliveryReservation && !this.storeInfo.isTakeoutReservation) {
                this.$public.showNotify('不開放預點');
              } else {
                this.isOpenPickTime = true
              }
            },
            closePickTime(obj){
              if (obj.isChangeRadioTake) {
                this.radioTake = obj.radioTake
              }

              if (obj.isChangePosMenu) {
                this.$router.replace({name: 'OrderList', query:{ id: this.storeId, reservationTime: this.storeInfo.reservationTime}});
              }
              this.isOpenPickTime = false
            },
            updateOrderSettingTypeId() {
                let orderSettingTypeId = 0
                if(this.isCordova || this.isOnlineOrder) {
                    if(this.radioTake === "1") {
                        orderSettingTypeId = constDefine.OrderSettingType.Takeout
                    } else if(this.radioTake === "2") {
                        orderSettingTypeId = constDefine.OrderSettingType.Delivery
                    }
                } else {
                    orderSettingTypeId = constDefine.OrderSettingType.Table
                }
                this.orderSettingTypeId = orderSettingTypeId
                this.$store.commit(mutationTypes.setOrderSettingTypeId, orderSettingTypeId);
            }
        },
        watch:{
            deliveryFee:{
                handler:function (newVal, oldVal) {
                    let radioTake = this.radioTake
                    if(this.isDelivery) {
                        this.isDelivery = false
                        this.radioTake = String(constDefine.RADIO_TAKE.delivery);
                    }
                    let finalPrice = this.finalPrice || this.$store.state.cartPageSnapshot.finalPrice
                    if (newVal === Infinity) {
                        this.radioTake = String(constDefine.RADIO_TAKE.takeout);

                        if (radioTake === String(constDefine.RADIO_TAKE.delivery)) {
                            let isDistance = false
                            this.deliveryConditionList.forEach((item,index)=>{
                                if (this.userAddressData.distance <= item.distance) {
                                    isDistance = true
                                }
                            });
                            this.$public.showNotify((isDistance ? "未達外送消費金額門檻" : "您的所在地點超出外送服務範圍"), false);
                        }
                    }
                    this.getOrderGiftCouponApi(finalPrice);
                },
                deep: true,
                immediate: true,
            },
            radioTake:{
                handler:function (newVal,oldVal) {
                    let reservationDateIndex = this.storeInfo.reservationDateIndex
                    let reservationPeriodIndex = this.storeInfo.reservationPeriodIndex

                    let reservationName = ""
                    if (newVal === "1" ) {
                      reservationName = "自取"
                      if(this.storeInfo.reservationTime !== '' && !this.storeInfo.isTakeoutReservation) {
                        this.$public.showNotify("不開放預點自取", false);
                        this.radioTake = oldVal;
                        return false
                      }
                    } else if (newVal === "2" ) {
                      reservationName = "外送"
                      if(this.storeInfo.reservationTime !== '' && !this.storeInfo.isDeliveryReservation) {
                        this.$public.showNotify("不開放預點外送", false);
                        this.radioTake = oldVal;
                        return false
                      }
                    }

                    let reservationTitle = this.storeInfo.reservationTime !== '' ? reservationName + " " + this.dateList[reservationDateIndex].dateText + " " + this.periodList[reservationPeriodIndex].period.slice(0, 5) : "立即 " + reservationName

                    this.$store.commit(mutationTypes.setOrderStoreInfo, {
                      reservationType: newVal,
                      reservationTitle: reservationTitle,
                    });

                    this.$store.commit("updateCartRadioTake",newVal);
                }
            },
            deep: false,
            immediate: false,
        },
        computed:{
            //外送費
            deliveryFee:function(){
                let temp = null;
                let isDistance = false
                this.deliveryConditionList.forEach((item,index)=>{
                    if (this.userAddressData.distance <= item.distance && this.originTotalPrice >= item.requiredAmount&&(temp === null || item.deliveryFee < temp.deliveryFee)) {
                        temp = item;
                    }

                    if (this.userAddressData.distance <= item.distance) {
                        isDistance = true
                    }
                });

                if (this.isDelivery && temp === null) {
                    this.$public.showNotify((isDistance ? "未達外送消費金額門檻" : "您的所在地點超出外送服務範圍"), false);
                }

                let result = temp?temp.deliveryFee:Infinity;
                this.$store.commit("updateCartDeliveryFee",result);
                return result;
            },
            userAddressTime:function(){
              let userAddressTime = 0;
              if (this.radioTake==='2') {
                userAddressTime = this.userAddressData.time
              }
              return userAddressTime
            },
        },
    }
</script>